"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var TextBlock_styles_1 = require("../Base/TextBlock.styles");

var BodyTextBlockWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: left;\n\n  ", " {\n    text-transform: initial;\n    ", "\n  }\n\n  ", " {\n    margin-top: 8px;\n    margin-bottom: 16px;\n    ", "\n  }\n"], ["\n  text-align: left;\n\n  ", " {\n    text-transform: initial;\n    ", "\n  }\n\n  ", " {\n    margin-top: 8px;\n    margin-bottom: 16px;\n    ", "\n  }\n"])), TextBlock_styles_1.BaseTitle, function (props) {
  return props.theme.font.label.v400;
}, TextBlock_styles_1.BaseDescription, function (props) {
  return props.theme.font.body.v200;
});
exports.default = BodyTextBlockWrapper;
var templateObject_1;